
<template>
  <button @click="btnClickedHandler()" class="button">{{buttonText}}</button>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
  name: "ButtonCellRenderer",
  setup(props: any) {

    const { params } = toRefs(props);
    const buttonText = params.value.buttonText;  
    const rowData = params.value.node.data;
    const clicked = params.value.clicked;


    function btnClickedHandler() {
      this.params.clicked(rowData);
    }

    return {
      buttonText,
      btnClickedHandler,
    };
  },
});
</script>

<style  scoped>
.button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  
  background:gray;
  color: #ffffff;
  
  margin: 0;
  padding: 0.5rem 1rem;
  
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1.1rem;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  
  border: none;
  border-radius: 4px;
  
  display: inline-block;
  width: auto;
  
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  
  cursor: pointer;
  
  transition: 0.5s;
}
</style>